import { render } from "./PrivilegesView.vue?vue&type=template&id=6e33aa09"
import script from "./PrivilegesView.vue?vue&type=script&lang=js"
export * from "./PrivilegesView.vue?vue&type=script&lang=js"

import "./PrivilegesView.vue?vue&type=style&index=0&id=6e33aa09&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__